import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AUTH_REDIRECT_DELAY } from '../../constants/timing';
import { clearLocalStorageStatistics } from '../../utils/statsCleanup';
import authService from '../../services/auth';
import './AuthCallback.scss';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState('Processing...');
  
  // Check if this is a dev route
  const isDevMode = location.pathname.startsWith('/dev/');

  useEffect(() => {
    // If in dev mode, just show the component without processing
    if (isDevMode) {
      setStatus('Processing...');
      return;
    }

    const handleCallback = async () => {
      try {
        // Use auth service to handle OAuth callback
        const user = await authService.handleOAuthCallback(searchParams);
        
        // Clear localStorage statistics since user is now authenticated
        clearLocalStorageStatistics();
        
        // Refresh the auth context to pick up the new authentication state
        await refreshUser();
        
        // Check if user needs to set username
        if (!user.username) {
          setStatus('Welcome! Setting up your profile...');
          // Use React Router navigation instead of full page reload
          setTimeout(() => {
            navigate('/username-setup', { replace: true });
          }, AUTH_REDIRECT_DELAY);
        } else {
          setStatus('Welcome back! Redirecting...');
          // Use React Router navigation instead of full page reload
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 1500);
        }
      } catch (error) {
        console.error('Authentication error:', error);
        setStatus(`Authentication failed: ${error.message}. Redirecting...`);
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, isDevMode]);

  return (
    <div className="auth-callback-page">
      <div className="auth-callback-container">
        <div className="loading-spinner"></div>
        <h2>Signing you in...</h2>
        <p>{status}</p>
      </div>
    </div>
  );
};

export default AuthCallback;